import { InjectionToken } from '@angular/core';

import { ITileModalData } from './tile-modal.interface';

export const tileModalDataToken = new InjectionToken<ITileModalData>('TileModalData');

